import React, { useEffect, useState } from "react";
import { Menu } from "../Menu";
import { useHistory } from "react-router-dom";

export const Pagar = async () => {
    const [linkPago, setLinkPago] = useState(null);

    // Cuota seleccionada para pagar
    let cuota_seleccionada = JSON.parse(localStorage.getItem("cuota_pagar"));

    let cuit_loggeado = atob(sessionStorage.getItem("dtdc"));
    let id_plan_seleccionado = atob(sessionStorage.getItem("dtpln"));
    const tokenLogin = atob(sessionStorage.getItem('dttk'));

    const history = useHistory();

    useEffect(() => {
        const asyncFunction = async () => {
            const endpoint = await (await fetch('/api/show_endpoints/wsmisplanes')).json();
            const brand = await (await fetch('/api/get_brand')).json();
            fetch(
                `${endpoint.url_base}${endpoint.url_variable}?CUIT=${cuit_loggeado}&Brand=${brand.nombre}&TokenLogin=${tokenLogin}`,
                {
                    cache: "no-cache",
                }
            )
                .then(res => res.json())
                .then(result => {
                    if(!Object.entries(result).length)
                        history.push('/login_mi_plan');
                    let planes = result.Usuario.Datos.Planes.Plan;
                    let plan_filtrado = planes.filter(function(element) {
                        return element.Id == id_plan_seleccionado;
                    });

                    let cuotas = plan_filtrado[0].Cuotas.Cuota;
                    let cuota_filtrada = cuotas.filter(function(element) {
                        return element.Cuota == cuota_seleccionada;
                    });
                    setLinkPago(cuota_filtrada[0].LinkPago);
                });
        }
        asyncFunction();
    }, [])

    return (
        <div>
            <Menu />
            <div className="pagar">
                <iframe
                    id="inlineFrameExample"
                    title="Inline Frame Example"
                    width="50%"
                    height="50%"
                    scrolling="no"
                    src={linkPago}
                ></iframe>
            </div>
        </div>
    );
};
